import qs from 'qs';

app.BiteLogList = app.HistoryAwareCollection.extend({
  model: app.BiteLog,

  initialize(models, options) {
    app.AbstractCollection.prototype.initialize.apply(this, arguments);
    this.filterParams = {};
  },

  comparator(model) {
    return model.get('createdAt') * -1;
  },

  _getFilterParams() {
    return this.filterFieldGroupView?.getValue() ?? this.filterParams;
  },

  _hasFilterParams() {
    return Object.values(this._getFilterParams()).some((value) => {
      return value !== null && value !== undefined;
    });
  },

  isValidQuery(query) {
    return query?.length > 3 || this._hasFilterParams();
  },

  fetchWithFilter(params, onFetchComplete) {
    this.filterParams = params;
    this.fetch({
      url: this.url(),
      reset: true,
      success() {
        onFetchComplete();
      },
      error(collection, err) {
        onFetchComplete(err);
      },
    });
  },

  url() {
    const params = {
      ...(this.query && { query: this.query }),
      ...this._getFilterParams(),
    };

    const paramsStr = qs.stringify(params, { skipNulls: true });
    return `/api/v2/bite-logs${paramsStr ? `?${paramsStr}` : ''}`;
  },
});
